<template>
  <v-row>
    <v-col cols="12">
      <div class="text-body-1 px-5 pb-2">
        <b>{{makerName}}</b>が開発した<b>{{gameName}}</b>の日本語化に関するページです。<br/>
      </div>
      <div class="text-body-1 px-5 py-2" v-if="makerLink">
        <b>{{makerName}}</b> 公式サイト<br/>
        <a :href=makerLink target="_blank">{{makerLink}}</a>
      </div>
      <div class="text-body-1 px-5 pt-2">
        Steam：<b>{{gameName}}</b><br/>
        <a :href=gameLink target="_blank">{{gameLink}}</a>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'GameInfo',
  props: {
    gameName: String,
    gameLink: String,
    makerName: String,
    makerLink: String
  },
}
</script>

<style>
</style>